import { Box, Slider, Stack, Typography } from "@mui/material";
import type { CalculatorFormValues } from "Components/Merchant/FeeCalculator/schema";
import { FormInput } from "Components/Shared/Inputs/Form/FormInput";
import { type Control, Controller } from "react-hook-form";

type Props = {
  label: string;
  description?: string;
  inputEndAdornment?: string;
  name: keyof CalculatorFormValues;
  control: Control<CalculatorFormValues>;
  inputWidth?: number;
  min?: number;
  max?: number;
  step?: number;
};

export const InputWithSlider = ({
  name,
  label,
  control,
  description,
  inputEndAdornment,
  min = 1,
  max = 10_000,
  step = 50,
  inputWidth = 24,
}: Props) => (
  <>
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      gap={5}
    >
      <Stack>
        <Typography component="label" htmlFor={name} variant="h6">
          {label}
        </Typography>
        {description && <Typography>{description}</Typography>}
      </Stack>
      <Box width={({ spacing }) => spacing(inputWidth)}>
        <FormInput
          inputEndAdornment={<Typography>{inputEndAdornment}</Typography>}
          disablePadding
          control={control}
          name={name}
          disableHelperText
          mask={Number}
          scale={3}
          isNumber
        />
      </Box>
    </Box>
    <Box display="flex" alignItems="center" gap={2} mb={2}>
      <Box flexGrow={1}>
        <Controller
          control={control}
          name={name}
          render={({ field }) => (
            <Box sx={{ px: 2, py: 1 }}>
              <Slider
                {...field}
                min={min}
                max={max}
                step={step}
                sx={{
                  "& .MuiSlider-rail": {
                    backgroundColor: "#80B3FF",
                  },
                }}
              />
            </Box>
          )}
        />
      </Box>
    </Box>
  </>
);
